import Title from "./Title";
import Banner from "./Banner";
import React, { useState } from "react";
import Layout from "../../Layout/Layout";



function ManageHero() {

    const [IsTitle, setIsTitle] = useState(true);

    const handleTitleandBanner = (value) => {
        if (value === "Title") {
            setIsTitle(true);
        } else {
            setIsTitle(false);
        }
    }


    return (
        <Layout>
            <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">

                <div className="flex space-x-4 justify-center mb-6">
                    <button
                        onClick={() => handleTitleandBanner("Title")}
                        className={`px-6 py-3 rounded-lg font-semibold text-sm transition-all transform hover:scale-105 ${IsTitle
                                ? "bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-xl"
                                : "bg-white text-gray-700 border-2 border-gray-300 hover:border-gray-400"
                            }`}
                    >
                            Add Title
                        </button>
                    <button
                        onClick={() => handleTitleandBanner("Banner")}
                        className={`px-6 py-3 rounded-lg font-semibold text-sm transition-all transform hover:scale-105 ${!IsTitle
                                ? "bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-xl"
                                : "bg-white text-gray-700 border-2 border-gray-300 hover:border-gray-400"
                            }`}
                    >
                        Add Banner
                    </button>
                </div>
                {
                    IsTitle ? <Title /> : <Banner />
                }

            </main>
        </Layout>
    )
};
export default ManageHero;